export default {"src":"/_next/static/media/icon-integration.b9b77102.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};